import { useState } from 'react';

const faqs = [
  { q: 'How does your streaming service work?', a: 'After subscribing, you receive your login credentials within 5 minutes. You can then install our app on any compatible device and start watching thousands of live channels and an extensive library of movies & series instantly.' },
  { q: 'Which devices can I use the service on?', a: 'Our service is compatible with Smart TV (Samsung, LG, Sony), Android TV, Amazon Fire Stick, smartphones (iOS & Android), tablets, and computers (Windows, Mac, Linux).' },
  { q: 'What internet speed is required?', a: 'We recommend at least 10 Mbps for HD quality and 25 Mbps for 4K Ultra HD streaming. A stable connection ensures the best experience.' },
  { q: 'How does the free 24h trial work?', a: 'Simply contact us via WhatsApp or fill out the form. We activate your free 24-hour trial within minutes — no credit card required, no commitment.' },
  { q: 'Is the service reliable? Are there any interruptions?', a: 'Our servers use Anti-Freeze technology to ensure seamless streaming. We maintain 99.9% uptime and our team monitors the service 24/7.' },
  { q: 'What payment methods do you accept?', a: 'We accept PayPal, credit/debit cards, bank transfer, and various other payment methods. Contact us on WhatsApp for details.' },
  { q: 'How long does activation take?', a: 'Activation is instant — you receive your credentials within 5 minutes of payment confirmation.' },
  { q: 'Can I use the service abroad?', a: 'Yes! Our service works worldwide. Whether you are in Europe, America, Africa or Asia, you can enjoy all channels and content.' },
];

const FAQ = () => {
  const [open, setOpen] = useState<number | null>(null);
  return (
    <section className="py-12 sm:py-16 md:py-20 bg-gradient-to-b from-gray-950 to-black relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 relative z-10">
        <div className="text-center mb-10 sm:mb-14">
          <div className="inline-flex items-center gap-2 bg-[#862ce0]/10 border border-[#862ce0]/20 rounded-full px-4 py-2 mb-4 sm:mb-6">
            <span className="text-sm font-medium text-[#b47ef3]">FAQ</span>
          </div>
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold mb-3 sm:mb-4 text-white">
            Frequently Asked <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#862ce0] to-[#c026d3]">Questions</span>
          </h2>
          <p className="text-gray-400 text-base sm:text-lg max-w-2xl mx-auto">Everything you need to know before subscribing</p>
        </div>
        <div className="max-w-3xl mx-auto space-y-4">
          {faqs.map((faq, i) => (
            <div key={i} className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-xl px-6 transition-colors hover:border-[#862ce0]/30">
              <button
                type="button"
                className="flex flex-1 items-center justify-between w-full text-left text-white hover:text-[#b47ef3] py-5 text-base sm:text-lg font-medium cursor-pointer"
                onClick={() => setOpen(open === i ? null : i)}
              >
                {faq.q}
                <i className={`ri-arrow-down-s-line text-xl flex-shrink-0 transition-transform duration-200 ${open === i ? 'rotate-180' : ''}`}></i>
              </button>
              {open === i && (
                <div className="pb-5 text-gray-400 text-sm sm:text-base leading-relaxed">{faq.a}</div>
              )}
            </div>
          ))}
        </div>
        <div className="mt-10 sm:mt-14 text-center">
          <p className="text-gray-400 mb-4">Do you have other questions?</p>
          <a href="https://wa.me/12057092376" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 bg-gradient-to-r from-[#862ce0] to-[#c026d3] text-white px-6 py-3 rounded-full font-semibold hover:opacity-90 transition-opacity cursor-pointer">
            <i className="ri-whatsapp-line"></i> Contact us on WhatsApp
          </a>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
